import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';

import { Stadium } from '@sorare/core/src/components/animations/Stadium';

const StadiumWrapper = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
`;

export const FixtureRewardsTrckPage = () => {
  const { fieldUrl } = useOutletContext<{ fieldUrl: string }>();

  return (
    <StadiumWrapper>
      <Stadium fieldUrl={fieldUrl} completion={1} />
    </StadiumWrapper>
  );
};

export default FixtureRewardsTrckPage;
